import { Outlet } from "react-router-dom";
import DashShell from "@/components/dash/DashShell";
import { useSeo } from "@/lib/seo";

const LINKS = [
  [null, "Academics"],
  ["/admin", "Academic Overview", true], ["/admin/students", "Student Records"], ["/admin/cohorts", "Classes & Cohorts"],
  ["/admin/leads", "Admissions & Interest"], ["/admin/operators", "Faculty"], ["/admin/ledger", "Tuition & Revenue"],
  [null, "Consulting Records"],
  ["/admin/customers", "Consulting Clients"], ["/admin/products", "Consulting Products"],
  [null, "Website"],
  ["/admin/health", "Property Health"], ["/admin/content", "SEO Content"], ["/admin/reviews", "Reviews"], ["/admin/experiments", "Experiments"],
];

export default function AdminLayout() {
  useSeo({ title: "Education Center Administration", noindex: true });
  return <DashShell brandLabel="Education Center Administration" links={LINKS}><Outlet /></DashShell>;
}
